import axios from 'axios';

const loadAbort = () => {
    return new AbortController();
};

export const updateProperUserRolesEndpoint = (token: string, userId: string, roleId: string) => {
    const controller = loadAbort();
    return {
        call: (urlService: string) =>
            axios({
                method: 'put',
                url: `${urlService}/user/v1/admin/internal-users/${userId}/assign-role/proper`,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                data: {
                    role_id: roleId,
                },
            }),
        controller,
    };
}

export const getProperUserAssignedRolesEndpoint = (token: string, userId: string) => {
    const controller = loadAbort();
    return {
        call: (urlService: string) =>
            axios({
                method: 'get',
                url: `${urlService}/user/v1/admin/proper/${userId}/assigned-roles`,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
            }),
        controller,
    };
}

export const removeProperUserRoleEndpoint = (token: string, userId: string, roleId: string) => {
    const controller = loadAbort();
    return {
        call: (urlService: string) =>
            axios({
                method: 'delete',
                url: `${urlService}/user/v1/admin/proper/${userId}/assigned-role`,
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: `Bearer ${token}`,
                },
                data: {
                    role_id: roleId,
                },
            }),
        controller,
    };
}

